import React, {useState, useEffect, useRef, createRef} from 'react';
import Konva from 'konva';
import ParticlesBg from 'particles-bg';
import {Stage, Layer, Circle} from 'react-konva';
import _ from 'lodash';
const {lerp} = require('canvas-sketch-util/math');
const random = require('canvas-sketch-util/random');

const DotsComponent = () => {

  let config = {
    num: [1, 1],
    rps: 0.1,
    radius: [5, 40],
    life: [1.5, 3],
    v: [1, 1],
    tha: [-40, 40],
    body: '/page-decor/blue-irad-symbol.svg', // Whether to render pictures
    // rotate: [0, 20],
    alpha: [0.6, 0],
    scale: [0.5, 0.1],
    position: 'all', // all or center or {x:1,y:1,width:100,height:100}
    cross: 'dead', // cross or bround
    random: 4,  // or null,
  }

  let configTwo = {
    num: [1, 1],
    rps: 0.1,
    radius: [5, 40],
    life: [1.5, 3],
    v: [1, 1],
    tha: [-40, 40],
    body: '/page-decor/orange-irad-symbol.svg', // Whether to render pictures
    // rotate: [0, 20],
    alpha: [0.6, 0],
    scale: [0.5, 0.1],
    position: 'all', // all or center or {x:1,y:1,width:100,height:100}
    cross: 'dead', // cross or bround
    random: 4,  // or null,
  }

    return (
        <>
            <ParticlesBg config={configTwo} type="custom" bg={true} />
            <ParticlesBg config={config} type="custom" bg={true} />
        </>
    );
}

export default DotsComponent;
